import { Card } from '@/components/Elements'
import { Select } from '@/components/Form'
import { useAdminFunction } from '@/features/adminFunction/useAdminFunction'
import useOffer from '@/features/offers/hooks/useOffer'
import useOfferList from '@/features/offers/hooks/useOfferList'
import { hideLoadingOverlay, showLoadingOverlay } from '@/stores/ui/loadingOverlaySlice'
import { Box, Button, Flex } from '@chakra-ui/react'
import { OfferStatus } from '@eapproval/offer-shared'
import { useState } from 'react'
import { FormProvider, useFieldArray, useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'

const SendQuotationCompletedEmailCard = () => {
  const methods = useForm({
    defaultValues: {
      offers: [],
    },
  })

  const { useOfferOptions } = useOfferList()
  const { useBatchSendQuotationCompletedEmail } = useAdminFunction()
  const batchSendQuotationCompletedEmail = useBatchSendQuotationCompletedEmail()
  const { data: offerOptions } = useOfferOptions({ status: OfferStatus.QUOTATION_COMPLETED })

  const { fields: offers, append: appendOffer } = useFieldArray({
    control: methods.control,
    name: 'offers',
  })
  const dispatch = useDispatch()
  const handleAddOffer = () => {}
  const onSubmit = async (data) => {
    console.log('Submitted Data: ', data)

    try {
      dispatch(showLoadingOverlay())
      await batchSendQuotationCompletedEmail.mutateAsync(data)
    } catch (err) {
      console.error(err)
    } finally {
      dispatch(hideLoadingOverlay())
    }
  }
  return (
    <Card title="Batch Send Offer Quotation Completed Email">
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <Box p={5}>
            <Flex direction="column" gap="3">
              <Select name={`offerIds`} label="Offer" isRow options={offerOptions} isMulti />
            </Flex>
            <Button mt="6" colorScheme="blue" type="submit">
              Send
            </Button>
          </Box>
        </form>
      </FormProvider>
    </Card>
  )
}

export default SendQuotationCompletedEmailCard
